export enum Placement {
  RIGHT = "right",
  RIGHT_START = "right-start",
  RIGHT_END = "right-end",
  LEFT = "left",
  LEFT_START = "left-start",
  LEFT_END = "left-end"
}
